import getLocal from '@/app/utils/getLocal';
import { useGlobal } from '@/utils/useGlobal';
import { useEffect } from 'react';
import { useProductDispatch, useProductStore } from '../../ProductProvider';
import { getProductFromGeneralKey, getProductMsg } from '@/utils/productGetServerSideProps';
import { productDetailData } from '@/service';

export interface GeneralKeyItemProps {
    key: string;
    url: string;
}

export default function GetProductData() {
    const { gloproductlist } = useGlobal();
    const { productPageData } = useProductStore();
    const dispatch = useProductDispatch();
    const { locale } = getLocal();
    const generalKeys: GeneralKeyItemProps[] = [
        { key: 'product_ps_delta_delta_3', url: 'delta-3-portable-power-station' },
    ];

    useEffect(() => {
        const getProductSeriesData = async () => {
            const promiseAll = new Set();
            let proMsgAll: any[] = [];
            const productPageData = {
                productCatagory: null,
                productSeries: [],
                supportDataArr: [],
            };
            let len = 0;
            generalKeys?.map((item: GeneralKeyItemProps) => {
                const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: item.key });
                if (Object.keys(productMsg)?.length > 0) {
                    proMsgAll.push(productMsg);
                    promiseAll.add(productDetailData({ handle: item.url }, locale || 'us'));
                    len++;
                    promiseAll.add(getProductMsg(locale, productMsg));
                    len++;
                }
            });

            try {
                const res: any = await Promise.all(promiseAll);
                if (proMsgAll?.length > 0 && len > 0 && res) {
                    const [productRes, supportRes] = res;

                    if (productRes?.code === '0') {
                        productPageData.productCatagory = productRes?.data?.productCatagoryResponseList;
                        productPageData.productSeries.push(productRes?.data?.spuResponse);
                    }

                    if (supportRes) {
                        productPageData.supportDataArr.push({
                            supportData: supportRes?.supportData,
                            prodectDetail: proMsgAll[0],
                        });
                    }

                    dispatch({
                        type: 'changeProductPageData',
                        payload: productPageData,
                    });
                }
            } catch (e: any) {
                console.error('error', e);
            }
        };

        const productCatagory = productPageData?.productCatagory;
        if (!productCatagory) {
            getProductSeriesData();
        }
    }, []);

    return null;
}
